/* NOBO — apparition douce des sections au défilement (JS natif, sans dépendance). */
(() => {
  const root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = () => {
    const sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    sections.forEach((section, index) => {
      // La première section (bannière) a sa propre animation.
      if (index === 0) return;
      // Les étapes épinglées et sections à apparitions détaillées gèrent leur propre mouvement.
      if (section.querySelector('[data-nobo-stage], .nobo-terms')) return;
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight) return;
      section.classList.add('nobo-reveal');
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Reflet doré à chaque clic sur un bouton ou une carte « brillante » */
(() => {
  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-nobo-shine]') : null;
    if (!target) return;
    target.classList.remove('is-shining');
    void target.offsetWidth;
    target.classList.add('is-shining');
    setTimeout(() => target.classList.remove('is-shining'), 950);
  });
})();
